import {
  FieldArray, useField,
  // FieldArrayRenderProps,
  // useField,
} from "formik";
import React, { useState } from "react";
import { Chip, Grid } from "@mui/material";
import {
  SelectAutocomplete,
} from "components/haven-design/form/select";
import { ContactPickerOtherDialog } from "./contact-picker-other";

export type Contact = {
  name: string;
  email?: string | null;
  mobile?: string | null;
  userEmail?: string | null;
  userMobile?: string | null;
  type?: "other" | "household" | "applicant";
  otherType?: string | null;
};

const getChipLabel = (value:Contact):string => {
  if (value.type === "other") {
    return `${value.otherType} - ${value.email}; ${value.mobile}`;
  }
  return value.name;
};

// eslint-disable-next-line import/no-unused-modules
export const ContactPicker: React.FC<{
  name: string;
  options: Contact[];
  selected: Contact[];
// eslint-disable-next-line max-lines-per-function
}> = ({ name, options, selected }) => {
  const [,, { setValue }] = useField(name);
  const [isOpen, setIsOpen] = useState(false);
  const other:Contact = { name: "Other...", type: "other" };

  const onOtherSubmit = (value:Contact) => {
    setValue(selected.concat(value));
    setIsOpen(false);
  };

  return (<FieldArray name={name} render={
    () => (
      <Grid container>
        <Grid size={{ xs: 12 }}>
          <SelectAutocomplete
            multiple
            size="small"
            filterSelectedOptions
            label="To"

            /* @ts-ignore */
            options={options.concat([other])}

            /* @ts-ignore */
            getOptionLabel={(option) => option.name}

            /* @ts-ignore */
            value={selected}
            onChange={(_, value) => {

              /* @ts-ignore */
              if (value.includes(other)) {
                setIsOpen(true);
              } else {
                setValue(value);
              }
            }}
            renderTags={(values, getTagProps) => (
              values.map((value, index) =>
                <Chip

                  /* @ts-ignore */
                  key={value.name}
                  {...getTagProps({ index })}

                  /* @ts-ignore */
                  label={getChipLabel(value)} />)
            )}
          />
        </Grid>
        <ContactPickerOtherDialog
          isOpen={isOpen}
          onRequestClose={() => setIsOpen(false)}
          onSubmit={onOtherSubmit}/>
      </Grid>
    )
  } />);
};
